// extracted by mini-css-extract-plugin
export default {"progress":"PercentageBar_progress__ndj1z","barOverflow":"PercentageBar_barOverflow__gGvEv","bar":"PercentageBar_bar__z3cmc"};